export enum DocumentStatusEnum {
	SENT = 'SENT',
	VALID = 'VALID',
	PENDING = 'PENDING',
	INVALID = 'INVALID',
	EXPIRED = 'EXPIRED',
	EXPIRES_SOON = 'EXPIRES_SOON'
}
